import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)
const store = new Vuex.Store({
    state: {
        Token: JSON.parse(localStorage.getItem('Token')) ? JSON.parse(localStorage.getItem('Token')) : '',   
    },
    mutations: {

        // 修改token，并将token存入localStorage
    changeLogin (state, user) {
        state.Token = user.Token;
        localStorage.setItem('Token', JSON.stringify(user.Token));
      },
    },
})
export default store;


// WEBPACK FOOTER //
// ./src/vuex/index.js